import { NSARouterMakerResult } from 'namirasoft-account-react';
import { NotificationSenderLayout } from '../NotificationSenderLayout';
import { NotificationSenderEntity } from '../NotificationSenderEntity';
import { NotificationSenderProps } from '../NotificationSenderProps';
import { NamirasoftMap } from 'namirasoft-site-map';

interface ITopicListPageIProps extends NSARouterMakerResult, NotificationSenderProps
{ }

function TopicListPage(props: ITopicListPageIProps) 
{
    let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

    return (
        <NotificationSenderLayout
            {...props}
            action={{
                description: "View all Topics that have been created in your Namirasoft Notification Sender. This list includes key metrics like subscriber count, message delivery statistics, and usage activity for each Topic."
            }}
            pages={{
                entity: NotificationSenderEntity.Topic(props),
                list: {
                    ui: {
                        search_box: {
                            exclude: {
                                load_value: (table, column) =>
                                {
                                    if (namirasoft.notification_sender.tables.sent_topic.name === table)
                                    {
                                        let columns = [
                                            namirasoft.notification_sender.tables.sent_topic.columns.message.name,
                                        ]
                                        return columns.includes(column);
                                    }
                                    return false;
                                }
                            }
                        }
                    }
                }
            }}
        >
            <></>
        </NotificationSenderLayout >
    );
}

export default TopicListPage;